export default __webpack_public_path__ + "static/MWP-PATRONAT-Mieczysław-Struk-poziom-kolor-2021-b2c8f7a30ab2b529415d8e2cc475d97c.png";